<template>
    <span :class="[
        'uik-tag__wrapper',
        {'uik-tag__nowrap': nowrap},
        {'uik-tag__collapsed': collapsed},
        (fill ? 'uik-tag__fill':''),
        (color != '' ? color:'')
    ]">
        <span class="uik-tag__content">
            {{ text }}
            <slot></slot>
        </span>
    </span>
</template>

<script>
export default {
    name: "UikTag",
    props: {
        fill: { type: Boolean, default: false },
        color: { type: String, default: "" },
        text: { type: String, default: "" },
        nowrap: { type: Boolean, default: false },
        collapsed: { type: Boolean, default: false }
    }
}
</script>

<style lang="scss">
.uik-tag__wrapper {
  border-radius: 4px;
  /* ADMIN: */
  font-size: 0.75rem;
  text-transform: uppercase;
  text-align: center;
  line-height: 18px;
  display: inline-flex;
  align-items: center;
  border: $borderDefault;
  color: $textSecondary;
  font-weight: 500;
  padding: 0 7px;
  height: 24px;
  .uik-tag__content {
    user-select: none;
  }
  &:not(.uik-tag__fill) {
    @each $name,
    $color in $colors {
      &:global(.#{"" + $name}) {
        border: 1px solid $color;
        color: $color;
      }
    }
    &:global(.white) {
      border: 1px solid white;
      color: white;
    }
  }
  &.uik-tag__fill {
    @each $name,
    $color in $colors {
      &:global(.#{"" + $name}) {
        background: $color;
        border: 1px solid $color;
        color: white;
      }
    }
    &:global(.white) {
      background: white;
      color: black;
    }
  }
}
.uik-tag__nowrap {
  white-space: nowrap !important;
}
.uik-tag__collapsed,
.uik-container__collapsed .uik-tag__wrapper // Reference to state defined in TagContainer component
{
  border-radius: 50%;
  width: 10px;
  height: 10px;
  padding: 0;
  margin-top: 7px;
  margin-bottom: 7px;
  transition: all 0.18s;
  .uik-tag__content {
    opacity: 0;
    visibility: hidden;
  }
  &:hover {
    border-radius: 4px;
    width: auto;
    padding: 0 7px;
    height: 24px;
    margin-top: 0;
    margin-bottom: 0;
    .uik-tag__content {
      transition: all 0.18s;
      opacity: 1;
      visibility: visible;
    }
  }
}
</style>
